export const getEffectiveScopeFromParams = (searchParams: URLSearchParams, defaultScope?: string, defaultScopeRefId?: number | undefined) => {
    const s = searchParams.get("s") || "";
    const sid = Number(searchParams.get("sid")) || undefined;
    const effectiveScope = defaultScope ?? s;
    const effectiveScopeRefId = defaultScopeRefId ?? sid;

    return {
        effectiveScope: effectiveScope ?? "",
        effectiveScopeRefId
    };
};
